import * as AppConstants from 'app/AppConstants';
import {DASHBOARD_STATES} from 'constants/BibConstants';
import keyBy from 'lodash/keyBy';
import {concat} from 'utilities/Set';

const initialState = () => ({
  dashboardState: DASHBOARD_STATES.IDLE,
  dashboardType: null,
  industries: [],
  stackIdsByDepartmentId: {},
  stackDetails: {},
});

export default (state = initialState(), action) => {
  switch (action.type) {
    case AppConstants.BIB__LOAD_DASHBOARD_TYPE_STARTED: {
      return {
        ...state,
        dashboardState: DASHBOARD_STATES.LOADING,
      };
    }

    case AppConstants.BIB__LOAD_DASHBOARD_TYPE_FINISHED: {
      const {dashboardType} = action.payload;

      return {
        ...state,
        dashboardState: dashboardType
          ? DASHBOARD_STATES.SET
          : DASHBOARD_STATES.UNSET,
        dashboardType,
      };
    }

    case AppConstants.BIB__LOAD_DASHBOARD_TYPE_FAILED: {
      return {
        ...state,
        dashboardState: DASHBOARD_STATES.FAILED,
      };
    }

    case AppConstants.BIB__INDUSTRIES_LOADED: {
      const {industries} = action.payload;

      return {
        ...state,
        industries,
      };
    }

    case AppConstants.BIB__SAVE_DASHBOARD_TYPE_STARTED: {
      return {
        ...state,
        dashboardState: DASHBOARD_STATES.SAVING,
        dashboardType: action.payload.dashboardType,
      };
    }

    case AppConstants.BIB__SAVE_DASHBOARD_TYPE_FINISHED: {
      return {
        ...state,
        dashboardState: DASHBOARD_STATES.SET,
        dashboardType: action.payload.dashboardType,
      };
    }

    case AppConstants.BIB__SAVE_DASHBOARD_TYPE_FAILED: {
      return {
        ...state,
        dashboardState: DASHBOARD_STATES.UNSET,
      };
    }

    case AppConstants.BIB__LOAD_DASHBOARD_STACKS_FINISHED: {
      const {stacks, stacksId} = action.payload;
      const keyedStacks = keyBy(stacks, 'id');
      const stackIds = Object.keys(keyedStacks);

      return {
        ...state,
        stackIdsByDepartmentId: {
          ...state.stackIdsByDepartmentId,
          [stacksId]: concat(state.stackIdsByDepartmentId[stacksId], stackIds),
        },
        stackDetails: {
          ...state.stackDetails,
          ...keyedStacks,
        },
      };
    }

    default:
      return state;
  }
};
